export default __webpack_public_path__ + "static/media/user.14c4ac62.png";